
// GTM Configuration
export const GTM_CONFIG = {
  qa: 'GTM-PW5K',
  prod: 'GTM-PW5K'
};


export const getEnvironment = () => {
  const currentUrl = window.location.href;

  if (currentUrl.includes('paymentuiqa') || currentUrl.includes('localhost')) {
    return 'qa';
  } else {
    return 'prod';
  }
};

export const getGTMId = () => {
  const environment = getEnvironment();
  return GTM_CONFIG[environment];
};
